import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DocHorLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M20.5 11.5h-3.6c-.84 0-1.26 0-1.581-.164a1.5 1.5 0 0 1-.655-.655c-.164-.32-.164-.74-.164-1.581V5.5m1.703.703 3.594 3.594c.26.26.39.39.482.54q.124.204.18.434c.041.173.041.356.041.723V16.1c0 .84 0 1.26-.163 1.581a1.5 1.5 0 0 1-.656.656c-.32.163-.74.163-1.581.163H5.9c-.84 0-1.26 0-1.581-.163a1.5 1.5 0 0 1-.656-.656c-.163-.32-.163-.74-.163-1.581V7.9c0-.84 0-1.26.163-1.581a1.5 1.5 0 0 1 .656-.656c.32-.163.74-.163 1.581-.163h8.606c.367 0 .55 0 .723.041q.232.056.433.18c.152.093.281.223.54.482Z" })));
}
const DocHorLightCustom = forwardRef(_DocHorLightCustom);
export { DocHorLightCustom };
